import { useState } from "react";
import { useApp } from "../../common/contexts/AppContext";
import { Link } from "react-router-dom";
import ComponentStatusIcon from "./ComponentStatusIcon";
import DeleteModal from "../../common/components/DeleteModal";

function ListIncidents({
  incidents,
  onDelete,
  action,
  setAction,
  isDeleting,
  onClose,
}) {
  const [incidentToDelete, setIncidentToDelete] = useState(null);
  const { isOwner } = useApp();

  function deleteHandler(e) {
    const incidentId = e.target.id;
    setIncidentToDelete(incidentId);
  }

  function handleDeleteConfirmed() {
    onDelete(incidentToDelete);
    setIncidentToDelete(null);
  }

  function handleCloseModal() {
    setIncidentToDelete(null);
  }

  return (
    <div className="mt-6 flex flex-col space-y-4 ">
      {incidents?.map((component, i) => {
        const { name, lastUpdate, status = null, components, _id } = component;
        if (!(lastUpdate?.status?.label === "Resolved")) {
          return (
            <div
              key={i}
              className="bg-white dark:bg-slate-900 rounded-lg px-4 py-4 ring-1 ring-slate-900/5 shadow-sm border-2 border-t-orange-500"
            >
              {isOwner ? (
                <div className="buttonOp">
                  <button className="hover:bg-gray-200 rounded-md p-2 hover:text-blue-800 underline">
                    <Link to={`/incident/${_id}`}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="blue"
                        className="bi bi-pencil"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" />
                      </svg>
                    </Link>
                  </button>
                  <button
                    onClick={deleteHandler}
                    id={_id}
                    name={name}
                    className="delete-icon px-4"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="red"
                      className="bi bi-trash-fill"
                      viewBox="0 0 16 16"
                      id={_id}
                      name={name}
                    >
                      <path
                        id={_id}
                        d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5M8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5m3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0"
                      />
                    </svg>
                  </button>
                </div>
              ) : null}
              <h3 className="text-slate-900 dark:text-white mt-5 text-base font-medium tracking-tight">
                {name}
              </h3>
              <p className="inline-flex items-right justify-right p-2 bg-blue-500 rounded-md shadow-sm text-white mt-5">
                {lastUpdate?.status?.label}
              </p>
              <br />
              <br />
              {components?.map((comp, n) => {
                return (
                  <div key={n} className="mt-3 flex items-center gap-2">
                    <ComponentStatusIcon statusSlug={comp?.status?.slug} />
                    {comp?.name}
                  </div>
                );
              })}
            </div>
          );
        }
        return null;
      })}
      {incidentToDelete && (
        <DeleteModal
          title={`Are you sure, you want to delete this Incident ?`}
          open={true}
          setOpen={handleCloseModal}
          onDelete={handleDeleteConfirmed}
          isDeleting={isDeleting}
        />
      )}
    </div>
  );
}

export default ListIncidents;
